<div class="relative w-full block">
  @if (showArrow()) {
  <div
    class="hidden h-full w-full justify-between items-center absolute lg:flex"
  >
    <div
      class="absolute left-0 z-20 flex items-center justify-center border border-gray-seed rounded-full -ml-3"
      [ngClass]="{
        'hover:bg-white hover:border-white cursor-pointer': this.leftArrow
      }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="scrollToLeft()"
      >
        <path
          d="M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18"
          stroke="#A9A9A9"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      class="absolute right-0 z-20 flex items-center justify-center border border-gray-seed rounded-full -mr-3"
      [ngClass]="{
        'hover:bg-white hover:border-white cursor-pointer': this.rightArrow
      }"
      (click)="scrollToRight()"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18"
          stroke="#A9A9A9"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  }
  <div
    #swiper
    class="relative block w-full overflow-scroll outline-none hide-scrollbar scroll-smooth"
  >
    <div class="flex w-full">
      <div class="box-content flex items-center whitespace-nowrap">
        <div class="flex gap-5">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
